import Abstract from "./abstract";

export default class Delivery extends Abstract {
  #regionElement;
  #cityElement;
  #indexElement;
  #streetElement;
  #houseElement;
  #apartmentElement;

  #region;
  #city;
  #index;
  #street;
  #house;
  #apartment;

  #fillableTextElements = this.item.querySelectorAll(`.js-fill-text`);
  #inputsElements = this.fillableBlockElement.querySelectorAll(
    `input:not(.js-fill-postal, .js-fill-house, [data-input-fill-name="apartment"])`,
  );
  #radioInputs = this.item.querySelectorAll(`.js-personal-radio`);

  #radioName = this.#radioInputs.length && this.#radioInputs[0].name;

  FillableTextElementType = {
    region: `region`,
    city: `city`,
    street: `street`,
    house: `house`,
    index: `index`,
    apartment: `apartment`,
  };

  textValue = {
    [this.FillableTextElementType.region]: (value) => `${value},`,
    [this.FillableTextElementType.city]: (value) => value,
    [this.FillableTextElementType.street]: (value) => value,
    [this.FillableTextElementType.house]: (value) => value,
    [this.FillableTextElementType.index]: (value) => `Индекс ${value}`,
    [this.FillableTextElementType.apartment]: (value) => `кв. ${value}`,
  };

  constructor(item) {
    super(item);

    this.#regionElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.region}"]`);
    this.#cityElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.city}"]`);
    this.#indexElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.index}"]`);
    this.#streetElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.street}"]`);
    this.#houseElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.house}"]`);
    this.#apartmentElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.apartment}"]`);

    this.#region = this.#regionElement.value;
    this.#city = this.#cityElement.value;
    this.#index = this.#indexElement.value;
    this.#street = this.#streetElement.value;
    this.#house = this.#houseElement.value;
    this.#apartment = this.#apartmentElement.value;
  }

  getSubmitStatus() {
    return this.form[this.#radioName].value === `add` && this.#getValidateInputs();
  }

  #getValidateInputs() {
    const validate = [];
    this.#inputsElements.forEach((input) => {
      if (input.value.length) {
        validate.push(input);
      }
    });
    return validate.length === 3;
  }

  getFillStatus() {
    return (
      this.#region !== this.#regionElement.value ||
      this.#city !== this.#cityElement.value ||
      this.#index !== this.#indexElement.value ||
      this.#street !== this.#streetElement.value ||
      this.#house !== this.#houseElement.value ||
      this.#apartment !== this.#apartmentElement.value
    );
  }

  fillTextElements() {
    super.fillTextElements();

    if (this.getFillStatus()) {
      this.#fillableTextElements.forEach((textElement) => {
        const type = textElement.dataset.fillType;
        const value = this.item.querySelector(`[data-input-fill-name="${type}"]`).value;
        textElement.textContent = this.textValue[type](value);
      });
    }
  }
}
